import {StackCompat as Stack, mergeStyleSets} from 'components/FluentUICompat';
import React from 'react';
import {VexClusterItem, VexClusterOfVexClustersField} from './VexClusterItem';
import {RequirementsFieldName} from '../RequirementsFieldName';
import {useRequirementsTranslation} from '../useRequirementsTranslation';

interface Props {
	clusters: VexClusterOfVexClustersField[];
}

export const VexClustersField: React.FC<Props> = ({clusters}) => {
	const {t: getText} = useRequirementsTranslation();

	const renderCluster = (
		cluster: VexClusterOfVexClustersField,
	): React.ReactElement => {
		return <VexClusterItem cluster={cluster} key={cluster.id} />;
	};

	const classNames = mergeStyleSets({
		list: {
			paddingLeft: '1rem',
		},
	});

	const renderedClusters: React.ReactElement[] = clusters.map(renderCluster);

	return (
		<Stack horizontal>
			<RequirementsFieldName>{getText('VEX Cluster')}:</RequirementsFieldName>
			<ul className={classNames.list}>{renderedClusters}</ul>
		</Stack>
	);
};
